<template>
  <v-autocomplete
    :value="value"
    @input="$emit('input', $event)"
    :items="items"
    :loading="loading"
    :filter="customFilter"
    item-value="id_empleado"
    item-text="nombre_completo"
    :label="label"
    outlined
    dense
    clearable
    hide-details
    multiple
    chips
    small-chips
    deletable-chips
  >
    <!-- Selección (chips) -->
    <template v-slot:selection="{ item, index }">
      <v-chip
        small
        close
        class="ma-1"
        @click:close="removeItem(index)"
      >
        [{{ item.codigo }}] - {{ item.nombre_completo }}
      </v-chip>
    </template>

    <!-- Lista -->
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          [{{ item.codigo }}] - {{ item.nombre_completo }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "EmpleadoAutocomplete",
  props: {
    value: {
      // v-model
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Empleado'
    }
  },
  methods: {
    customFilter(item, queryText) {
      // Función para normalizar texto (sin acentos y en minúsculas)
      const normalize = (text) => {
        return text
          .toString()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
      };

      const normalizedQuery = normalize(queryText);
      const normalizedNombre = normalize(item.nombre_completo);
      const normalizedCodigo = normalize(item.codigo);

      // Buscar en nombre o código
      return (
        normalizedNombre.includes(normalizedQuery) ||
        normalizedCodigo.includes(normalizedQuery)
      );
    },
    removeItem(index) {
      const newValue = [...this.value];
      newValue.splice(index, 1);
      this.$emit('input', newValue);
    }
  }
};
</script>